import { createFileRoute, redirect } from "@tanstack/react-router";

// The landing page now lives at /vsl-v3. Keep the old public URL working and
// forward ad attribution (utm_*, fbclid, gclid) verbatim.
export const Route = createFileRoute("/apply")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: `/vsl-v3${location.searchStr ?? ""}${location.hash ? `#${location.hash}` : ""}`,
    });
  },
});
